(function () {
  const SELECTOR = '[data-cycology-story-hero]';

  class CycologyStoryHero {
    constructor(root) {
      this.root = root;
      this.swiperEl = root.querySelector('[data-cycology-swiper]');
      this.slides = Array.from(root.querySelectorAll('[data-cycology-slide]'));
      this.progressBars = Array.from(root.querySelectorAll('[data-cycology-progress]'));
      this.countCurrent = root.querySelector('[data-cycology-current]');
      this.countTotal = root.querySelector('[data-cycology-total]');
      this.prevButton = root.querySelector('[data-cycology-prev]');
      this.nextButton = root.querySelector('[data-cycology-next]');
      this.duration = Number(root.dataset.autoplaySpeed) || 3000;
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      const bounds = root.getBoundingClientRect();
      this.inView = bounds.width > 0 && bounds.bottom > 0 && bounds.top < window.innerHeight;

      if (!this.slides.length) return;

      this.bind();
      this.setSlide(this.currentIndex, false);
      this.root.classList.add('is-ready');
      this.start();
    }

    bind() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.progressBars.forEach((bar, index) => {
        bar.addEventListener('click', () => this.goTo(index));
      });

      this.swiperEl?.addEventListener('swiperslidechange', (event) => {
        const swiper = event.detail?.[0] || this.swiperEl.swiper;
        const nextIndex = swiper?.realIndex ?? swiper?.activeIndex ?? 0;
        if (nextIndex !== this.currentIndex) this.setSlide(nextIndex, true, true);
      });

      this.updateMedia = () => this.syncVideos();
      this.mediaQuery.addEventListener('change', this.updateMedia);
      document.addEventListener('visibilitychange', this.updateMedia);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        this.syncVideos();
      });
      this.observer.observe(this.root);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(this.root)) return;
        this.stop();
        this.observer.disconnect();
        this.mediaQuery.removeEventListener('change', this.updateMedia);
        document.removeEventListener('visibilitychange', this.updateMedia);
      });
    }

    goTo(index) {
      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (this.swiperEl?.swiper && this.swiperEl.swiper.activeIndex !== nextIndex) {
        this.swiperEl.swiper.slideTo(nextIndex);
        return;
      }

      this.setSlide(nextIndex, true, false);
    }

    setSlide(index, restart, fromSwiper = false) {
      this.stop();
      this.currentIndex = index;

      if (!fromSwiper && this.swiperEl?.swiper && this.swiperEl.swiper.activeIndex !== index) {
        this.swiperEl.swiper.slideTo(index, 0);
      }

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

      });
      this.syncVideos(true);

      this.updateCount();
      this.resetProgress();

      if (restart) this.start();
    }

    syncVideos(reset = false) {
      this.slides.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          const desktop = !!video.closest('.cycology-story-hero__media--desktop');
          const shouldPlay = index === this.currentIndex && desktop === this.mediaQuery.matches
            && this.inView && !document.hidden && video.getClientRects().length > 0;
          if (shouldPlay) {
            if (reset) video.currentTime = 0;
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    start() {
      this.animateProgress();
      this.timer = window.setTimeout(() => {
        this.goTo(this.currentIndex + 1);
      }, this.duration);
    }

    stop() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    updateCount() {
      if (this.countCurrent) this.countCurrent.textContent = String(this.currentIndex + 1);
      if (this.countTotal) this.countTotal.textContent = String(this.slides.length);
    }

    resetProgress() {
      this.progressBars.forEach((bar, index) => {
        const fill = bar.querySelector('.cycology-story-hero__progress-fill');
        bar.classList.toggle('is-complete', index < this.currentIndex);
        bar.classList.toggle('is-active', index === this.currentIndex);
        bar.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');

        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.transform = index < this.currentIndex ? 'scaleX(1)' : 'scaleX(0)';
      });
    }

    animateProgress() {
      const activeFill = this.progressBars[this.currentIndex]?.querySelector('.cycology-story-hero__progress-fill');
      if (!activeFill) return;

      activeFill.offsetHeight;
      activeFill.style.transition = `transform ${this.duration}ms linear`;
      activeFill.style.transform = 'scaleX(1)';
    }

    debounce(fn, wait) {
      let timer;
      return (...args) => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  function initCycologyStoryHeroes(scope) {
    const roots = Array.from((scope || document).querySelectorAll(SELECTOR));

    roots.forEach((root) => {
      if (root.cycologyStoryHero) return;
      root.cycologyStoryHero = new CycologyStoryHero(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCycologyStoryHeroes(document));
  document.addEventListener('shopify:section:load', (event) => initCycologyStoryHeroes(event.target));
})();
